import React, { Component } from 'react';
import SidebarMenuRouters from '../../routers/routers.js';
import Header from '../../containers/header.js';
import DirectoryTable from '../../components/tables/directoryTable';

class Quality extends Component {
  constructor(props) {
    super(props);
    let userData = JSON.parse(localStorage.getItem('userData'));
    this.state = {
      userData: userData,
      data: null,
    };
  }

  render() {

    return (
      <div>
        <SidebarMenuRouters profile="/direction-home/" place=''/>
        <Header userName={this.state.userData.name} title='Directorio'/>
        <div className='row justify-content-center'>
          <div className='header-directory'>
            <p>Directorio Implementta</p>
          </div>
        </div>
        <div className={'row pr-0 pl-0'}>
          <div className={'col-12 pr-0 pl-0 '}>
            <DirectoryTable/>
          </div>
        </div>
      </div>
    );
  }
}

export default Quality;



// WEBPACK FOOTER //
// ./src/scene/directory/directory.js